/**
 * App instance names
 */
export const VSUITE = 'vsuite';
export const VATIT = 'vatit';
